import LzIcon from './icon.vue'

LzIcon.install = function(Vue) {
	Vue.component(LzIcon.name, LzIcon);
}

export default LzIcon;
